var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 11.5417V12.5C22.9153 14.7463 22.1879 16.932 20.843 18.7311C19.498 20.5302 17.6075 21.8464 15.4534 22.4833C13.2993 23.1201 10.9971 23.0437 8.88999 22.2652C6.78292 21.4868 4.98393 20.048 3.76134 18.1636C2.53874 16.2792 1.95803 14.0501 2.10583 11.8087C2.25363 9.56728 3.12201 7.43369 4.58146 5.72614C6.04091 4.01858 8.01324 2.82854 10.2043 2.33351C12.3953 1.83847 14.6877 2.06496 16.7395 2.97919M22.9166 4.16669L12.4999 14.5938L9.37492 11.4688",
    stroke: "#3373EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle2);
export default __webpack_public_path__ + "static/media/check-circle2.9c81119778f9e753edac1f52ccbe6cd7.svg";
export { ForwardRef as ReactComponent };